export default __webpack_public_path__ + "static/media/fireworks-no-1.2065e452.ogg";